module.exports = __webpack_public_path__ + "static/monei_pay_starbucks_2_en-c2ebb47d83809a2d4dc23e35dbf4ce09.png";